export default "__VITE_ASSET__NLScCEIZ__"